// extracted by mini-css-extract-plugin
export default {"subscription":"subscription_st4H3","cover":"cover_Ms8jd","title":"title_u9tjZ"};